<ng-content></ng-content>
<option *ngFor="let item of keepingCurrentStatus || []" [value]="item.id">{{item.statusName}}</option>
